import "./Navbar.css";
import React, { useEffect, useState } from "react";
import { FaHome } from "react-icons/fa";
import { PiNotebookFill } from "react-icons/pi";
import { MdKeyboardArrowDown } from "react-icons/md";
import { GiDiscGolfBag } from "react-icons/gi";
import { RiMailOpenFill } from "react-icons/ri";
import { BsBank2 } from "react-icons/bs";
import { BiSolidPhoneCall } from "react-icons/bi";
import { IoIosArrowForward } from "react-icons/io";
import axios from "axios";
import MobileNavbar from "./MobileNavbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoWhite from "../../Assets/images/logoTechmentee.png";
import LogoColor from "../../Assets/images/logoTechmenteeColour.png";
const Navbar = () => {
  const [showNavLinks] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [catagoriesData, setCatagoriesData] = useState([]);
  const [programData, setProgramData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const path = useLocation()?.pathname;
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const getAllCatagories = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/courses-category/all-categories`,
      );

      setCatagoriesData(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  const getAllService = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/services/service-name`,
      );
      setServiceData(res.data.services);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const getPrograms = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/program/get-all-program`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("program", response.data);
        setProgramData(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllCatagories();
    getPrograms();
    getAllService();
  }, []);

  const navigateToProgram = (post) => {
    navigate(`/knowledge/program/${post._id}`);
  };
  const navigateToDetail = (post) => {
    navigate(`/course/${post._id}`);
  };
  return (
    <div>
      <nav
        className={`w-full ${
          path === "/"
            ? "text-black"
            : `${isScrolled ? "text-gray-500" : "text-white"} `
        }  ${
          isScrolled
            ? "bg-white  top-0 z-50 fixed text-gray-500 transition duration-500 ease-linear shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
            : " absolute z-50 text-black"
        }`}
      >
        {/* navbar */}
        <div className="navbar  lg:contents hidden ">
          <div
            className={`nav-links px-10 ${
              showNavLinks ? "show" : ""
            } flex xl:flex-row lg:flex-col justify-between`}
          >
            <div>
              <img
                src={
                  isScrolled ? LogoColor : path === "/" ? LogoColor : LogoWhite
                }
                alt=""
                className="w-[280px]"
              />
            </div>
            <ul className={`links flex items-center`}>
              <li>
                <div>
                  <Link to="/">
                    <FaHome size={30} />
                  </Link>
                </div>
              </li>
              <li>
                <Link
                  to="/about/about-techmentee"
                  className="flex items-center gap-1"
                >
                  <PiNotebookFill size={24} />
                  <div className="font-bold">About</div>
                </Link>
              </li>
              <li>
                <div className="flex items-center gap-1">
                  <GiDiscGolfBag size={24} />
                  <div>Services</div>
                  <MdKeyboardArrowDown />
                </div>
                <ul className={`htmlCss-sub-menu sub-menu`}>
                  {serviceData?.map((service) => (
                    <li key={service._id}>
                      <Link to={`/serviceDetails/${service._id}`}>
                        {service.heading}
                      </Link>
                    </li>
                  ))}

                  {/* <li>
                    <Link to={'/service/immigrationSupport'}>
                      Immigration Support
                    </Link>
                  </li> */}
                </ul>
              </li>
              <li>
                <div className="flex items-center gap-1">
                  <RiMailOpenFill size={24} />
                  <div>Courses</div>
                  <MdKeyboardArrowDown />
                </div>
                <ul className={`htmlCss-sub-menu sub-menu `}>
                  {catagoriesData?.map((ele, ind) => (
                    <li key={ind} className="more">
                      <div className="flex items-center justify-between gap-2">
                        <Link href="#">{ele?.categoryName}</Link>
                        <IoIosArrowForward />
                      </div>
                      <ul className={`more-sub-menu sub-menu `}>
                        {ele?.courses?.map((ele) => (
                          <li
                            onClick={() => navigateToDetail(ele)}
                            key={ele?._id}
                          >
                            <Link>{ele?.title}</Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              </li>
              <li className="min-w-10">
                <div className="flex items-center gap-1">
                  <BsBank2 size={24} />
                  <div>Knowledge Center</div>
                  <MdKeyboardArrowDown />
                </div>
                <ul className={`htmlCss-sub-menu sub-menu `}>
                  <li onClick={() => navigate(`/knowledge/process`)}>
                    <Link>Process</Link>
                  </li>
                  <li className="more">
                    <div className="flex items-center justify-between gap-2">
                      <Link href="#">Programs</Link>
                      <IoIosArrowForward />
                    </div>
                    <ul className={`more-sub-menu sub-menu `}>
                      {programData?.map((ele) => (
                        <li
                          key={ele?._id}
                          onClick={() => navigateToProgram(ele)}
                        >
                          <Link>{ele?.title}</Link>
                        </li>
                      ))}
                      <li className="more">
                        <div className="flex items-center justify-between gap-2">
                          <Link to="/knowledge/program/career-explorer">
                            Career Explorer
                          </Link>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <div className="flex items-center gap-1">
                  <BiSolidPhoneCall size={24} />
                  <div>Contact Us</div>
                  <MdKeyboardArrowDown />
                </div>
                <ul className={`htmlCss-sub-menu sub-menu `}>
                  <li onClick={() => navigate(`/contact-us/partner-with-us`)}>
                    <Link to="/contact-us/partner-with-us">
                      Partner With Us
                    </Link>
                  </li>
                  <li
                    onClick={() => navigate(`/contact-us/request-for-service`)}
                  >
                    <Link to="/contact-us/request-for-service">
                      Request For Service
                    </Link>
                  </li>
                  <li onClick={() => navigate(`/contact-us/feedback`)}>
                    <Link>Feedback</Link>
                  </li>
                  <li onClick={() => navigate(`/contact-us/career`)}>
                    <Link>Career</Link>
                  </li>
                </ul>
              </li>
              <div className="ml-2">
                <div>
                  <Link
                    className="bg-primaryOrangeColor hover:bg-orange-400 px-4 py-2 rounded text-white font-bold"
                    target="_blank"
                    to="https://techmentee-dashboard.vercel.app"
                  >
                    Login
                  </Link>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </nav>
      <MobileNavbar />
    </div>
  );
};

export default Navbar;
